<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="6">
                <restaurant-edit-form
                    title="Create new partner"
                    v-bind:isEditing="false"
                    v-bind:restaurant="restaurant"
                    v-on:submit="submit"
                    v-on:cancel="$router.go(-1)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import restaurantApi from '@/api/restaurantApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'restaurant-edit-form': () =>
            import('@/views/op/RestaurantEditForm.vue')
    },
    data() {
        return {
            restaurant: {
                name: null,
                phone: null,
                location_id: null,
                commission_threshold: 0,
                commission_percentage: 0,
                restaurateur: {
                    name: null,
                    phone: null,
                    username: null,
                    password: null,
                    password_confirmation: null
                }
            }
        };
    },
    methods: {
        async submit() {
            const response = await restaurantApi.createRestaurant(
                this.restaurant
            );
            this.$router.push({
                name: 'op-restaurant-show',
                params: { restaurant_id: response.data.restaurant.id }
            });
            snackbar.show('Partner created', 'success');
        }
    }
};
</script>
